import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { MatSnackBar, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { GenericRequiredDataComponent } from '../../dialog/generic-required-data/generic-required-data.component';
import { IGenericDialogDataRequired } from 'src/app/shared/interfaces';
import { DialogErrorModalComponent } from '../../dialog/dialog-error-modal/dialog-error-modal.component';
import { Dialog } from '@angular/cdk/dialog';
import { IDialogErrorData } from 'src/app/shared/interfaces';

@Injectable()
export class MessageDialogService {
  _snackBar = inject(MatSnackBar);
  _matDialog = inject(MatDialog);

  constructor() {}

  snackBarTopCenterTimed(message: string, duration: number): void {
    const verticalPosition: MatSnackBarVerticalPosition = 'top';

    this._snackBar.open(message, '', { duration: duration, verticalPosition: verticalPosition });
  }

  snackBarTopCenterStatic(message: string): void {
    const verticalPosition: MatSnackBarVerticalPosition = 'top';

    this._snackBar.open(message, '', { duration: 0, verticalPosition: verticalPosition });
  }

  // Red/error variant of snackBarTopCenterStatic - no auto-dismiss duration, no action button.
  snackBarErrorTopCenterStatic(message: string): void {
    const verticalPosition: MatSnackBarVerticalPosition = 'top';

    this._snackBar.open(message, '', {
      duration: 0,
      verticalPosition: verticalPosition,
      panelClass: 'error-snackbar',
    });
  }

  displayGenericDataRequiredDialog(title: string, primaryVerbiage: string): void {
    const dialogData: IGenericDialogDataRequired = {} as IGenericDialogDataRequired;

    dialogData.title = title;
    dialogData.primaryVerbiage = primaryVerbiage;

    const dialogRef = this._matDialog.open(GenericRequiredDataComponent, {
      data: dialogData,
      width: '400px',
      height: '400px',
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  displayGenericErrorDialog(primaryMessage: string, secondaryMessage: string, errorNumber: string): void {
    let enterAnimationDuration: string = '0ms';
    let exitAnimationDuration: string = '0ms';

    const dialogDisplayData: IDialogErrorData = {
      displayErrorMainMessage: primaryMessage,
      displayErrorSecondaryMessage: secondaryMessage,
      displayErrorNumber: errorNumber,
      errMessageCopyData: '',
    } as IDialogErrorData;

    const dialogRef = this._matDialog.open(DialogErrorModalComponent, {
      data: dialogDisplayData,
      hasBackdrop: true,
      width: '85vw',
      maxWidth: '90vh',
      panelClass: 'custom-dialog-container',
      enterAnimationDuration,
      exitAnimationDuration,
      position: {
        top: '200px',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }
}
